import React, {Fragment} from "react";
import {Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {getFormFieldValue, setFormFieldValue} from '../shared/shared';
import {Address} from "../components/Address";

export function PaymentInfo(props) {
  const {values, handleCB, readonly, token, formFields} = props;

  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h2>Payment Information</h2>
        </Col>
      </Row>

      <Row>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor="method">Payment Method*</Label>
            <Input type="select" name="method" id="method"
                   value={getFormFieldValue(values.method)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              <option key={1} value={"eft"}>EFT (Monthly)</option>
              {/*<option key={2} value={"CC"}>Credit/Debit Card Auto Pay</option>*/}
              <option key={3} value={"check"}>Check/Money Order</option>
              {/*<option key={4} value={"MAA"}>Military Allotment Authorization</option>*/}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      {getFormFieldValue(values.method) === "eft" && (
      <Fragment>
        <Row>
          <Col xs={"7"}>
            <FormGroup>
              <Label htmlFor="bankName">Bank Name*</Label>
              <Input type="text" id="bankName" placeholder=""
                     value={getFormFieldValue(values.bankName)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
            </FormGroup>
          </Col>
        </Row>

        <Address values={values || {}}
                 handleCB={(field, value) => setFormFieldValue(field, value, values, readonly, handleCB)}
                 thisId={"bank"} readonly={readonly} formFields={formFields} token={token}/>

        <Row>
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="routingNumber">Routing/Transit #*</Label>
              <TextMask
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                Component={InputAdapter}
                className="form-control"
                id={"routingNumber"}
                value={getFormFieldValue(values.routingNumber)}
                onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
              />
              <FormText color="muted">
                ex. 999999999
              </FormText>
            </FormGroup>
          </Col>
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="accountNumber">Checking Account Number*</Label>
              <Input type="text" id="accountNumber" placeholder=""
                     value={getFormFieldValue(values.accountNumber)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
            </FormGroup>
          </Col>
        </Row>

      </Fragment>
      )}
      {getFormFieldValue(values.method) === "check" && (
        <Fragment>
          <Row>
            <Col xs={"6"}>
              <FormGroup>
                <Label htmlFor="frequency">Frequency of Payment*</Label>
                <Input type="select" name="frequency" id="frequency"
                       value={getFormFieldValue(values.frequency)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}>
                  <option key={0} value={""} disabled={true}>Choose</option>
                  <option key={1} value={"Q"}>Quarterly</option>
                  <option key={2} value={"S"}>Semiannually</option>
                  <option key={3} value={"A"}>Annually</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </Fragment>
      )}

    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/PaymentInfo.js